// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 894) return "static/chunks/894-65f4b19ce1b1c3ae.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"41":"92a33cd77df763fc","976":"ab9f0664a0f41b2c"}[chunkId] + ".js";
};